import React, { Component } from "react";
import {
  Typography,
  Container,
  Box,
  Card,
  CardContent,
  CardMedia,
  Avatar,
  CircularProgress,
  Grid,
  Fab,
  Badge,
  IconButton,
  Tooltip,
  CardActionArea,
  Alert,
  AlertTitle,
  useTheme,
  useMediaQuery,
  Button,
  List,
  ListItemButton,
  ListItemText,
  Chip,
} from "@mui/material";
import { CartContext } from "../../comp/CartContext";
import {
  LocationOn as LocationOnIcon,
  ShoppingCart as ShoppingCartIcon,
  ViewList as ViewListIcon,
  ViewModule as ViewModuleIcon,
  ViewHeadline as ViewHeadlineIcon,
  InfoOutlined as InfoOutlinedIcon,
  Campaign as CampaignIcon,
  ArrowForward as ArrowForwardIcon,
  Category as CategoryIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Link } from "react-router-dom";
import { apiUrl } from "../../comp/ApiUrl";

const SEGMENT_LABELS = {
  1: { term: "Catálogo", desc: "produtos" },
  2: { term: "Cardápio", desc: "itens" },
  3: { term: "Catálogo", desc: "produtos" },
  4: { term: "Serviços", desc: "serviços" },
  5: { term: "Catálogo", desc: "produtos" },
  6: { term: "Serviços", desc: "serviços" },
  7: { term: "Catálogo", desc: "itens" },
};

const DEFAULT_LABEL = { term: "Catálogo", desc: "itens" };

class HomeDelivery extends Component {
  static contextType = CartContext;

  state = {
    store: {
      id: null,
      name: "",
      description: "",
      address: "",
      operatingHours: "",
      rating: 0,
      categories: [],
      products: [],
      cart: [],
      isLoading: true,
      banner: "",
      announcements: [],
      promotionalBanners: [],
    },
    error: null,
    activeCategoryAnchor: "",
    searchQuery: "",
    viewMode: this.props.isMobile ? "list" : "grid",
    userHasChangedViewMode: false,
  };

  observer = null;

  componentDidMount() {
    this.loadStoreData();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.isMobile !== this.props.isMobile &&
      !this.state.userHasChangedViewMode
    ) {
      this.setState({ viewMode: this.props.isMobile ? "list" : "grid" });
    }
  }

  componentWillUnmount() {
    if (this.observer) this.observer.disconnect();
  }

  getSegmentTerm = (segmentId) => {
    return SEGMENT_LABELS[segmentId]?.term || DEFAULT_LABEL.term;
  };

  loadStoreData = async () => {
    const data = this.context.data || {};
    const firstCategoryAnchor =
      data.categories?.length > 0 ? data.categories[0].anchor : "";

    this.setState(
      {
        store: {
          ...data,
          cart: data.cart || [],
          announcements: data.announcements || data.avisos || [],
          promotionalBanners: data.promotionalBanners || data.banners || [],
          isLoading: false,
        },
        activeCategoryAnchor: firstCategoryAnchor,
      },
      () => {
        this.initializeIntersectionObserver();
      }
    );
  };

  initializeIntersectionObserver = () => {
    const rootMargin = "-100px 0px -70% 0px";
    this.observer = new IntersectionObserver(this.handleObserver, {
      rootMargin,
    });
    this.state.store.categories.forEach((cat) => {
      const el = document.getElementById(cat.anchor);
      if (el) this.observer.observe(el);
    });
  };

  handleObserver = (entries) => {
    const activeEntry = entries.find((entry) => entry.isIntersecting);
    if (activeEntry && !this.state.searchQuery) {
      this.setState({ activeCategoryAnchor: activeEntry.target.id });
    }
  };

  scrollToCategory = (anchor) => {
    const element = document.getElementById(anchor);
    if (element) {
      const offset = this.props.isMobile ? 70 : 30;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
      this.setState({ activeCategoryAnchor: anchor });
    }
  };

  setViewMode = (mode) => {
    this.setState({ viewMode: mode, userHasChangedViewMode: true });
  };

  // HEADER DESKTOP ELEGANTE E REFINADO
  renderDesktopHeader() {
    const { name, logo, banner } = this.state.store;
    const address = this.state.store.address || {};
    const primaryColor = this.context.data.color || "#1976d2";

    return (
      <Box sx={{ bgcolor: "#ffffff", mb: 3.5, borderBottom: "1px solid #e2e8f0", boxShadow: "0 2px 10px rgba(0,0,0,0.02)" }}>
        <Box
          sx={{
            height: 180,
            bgcolor: primaryColor,
            backgroundImage: banner ? `url(/api/store/photo/${banner})` : "none",
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background: "linear-gradient(180deg, rgba(15,23,42,0.2) 0%, rgba(15,23,42,0.65) 100%)",
            }}
          />
        </Box>

        <Container maxWidth="lg">
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "space-between",
              mt: -5,
              pb: 2.5,
              position: "relative",
              zIndex: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "flex-end", gap: 3 }}>
              <Avatar
                src={`/api/store/photo/${logo}`}
                alt={name}
                sx={{
                  width: 104,
                  height: 104,
                  border: "4px solid #ffffff",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
                  bgcolor: "#ffffff",
                }}
              />
              <Box sx={{ mb: 0.5 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 0.5 }}>
                  <Typography variant="h4" sx={{ fontWeight: 800, color: "#0f172a", letterSpacing: "-0.02em" }}>
                    {name}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      px: 1.5,
                      py: 0.4,
                      borderRadius: 10,
                      bgcolor: "#ecfdf5",
                      color: "#059669",
                      fontWeight: 700,
                      fontSize: "0.75rem",
                      border: "1px solid #a7f3d0",
                    }}
                  >
                    <CheckCircleIcon sx={{ fontSize: 14 }} /> Aberto Agora
                  </Box>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "#64748b", fontSize: "0.9rem" }}>
                  <LocationOnIcon sx={{ fontSize: 18, color: primaryColor }} />
                  <Typography variant="body2" sx={{ fontWeight: 500, color: "#475569" }}>
                    {address.cidade || ""} {address.estado ? `- ${address.estado}` : ""}
                  </Typography>
                  <FiberManualRecordIcon sx={{ fontSize: 4, color: "#cbd5e1" }} />

                </Box>
              </Box>
            </Box>

            <Button
              component={Link}
              to="/sobre"
              variant="outlined"
              size="medium"
              startIcon={<InfoOutlinedIcon />}
              sx={{
                borderRadius: 2.5,
                textTransform: "none",
                fontWeight: 700,
                borderColor: "#cbd5e1",
                color: "#334155",
                px: 2.5,
                py: 0.8,
                transition: "all 0.2s ease",
                "&:hover": { borderColor: primaryColor, bgcolor: `${primaryColor}0A`, color: primaryColor },
              }}
            >
              Sobre a Loja
            </Button>
          </Box>
        </Container>
      </Box>
    );
  }

  // HEADER MOBILE APP
  renderMobileHeader() {
    const { name, logo, banner } = this.state.store;
    const address = this.state.store.address || {};
    const primaryColor = this.context.data.color || "#1976d2";

    return (
      <Box sx={{ bgcolor: "#fff", pb: 1.5, borderBottom: "1px solid #f1f5f9" }}>
        <Box
          sx={{
            height: 100,
            bgcolor: primaryColor,
            backgroundImage: banner ? `url(/api/store/photo/${banner})` : "none",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Box sx={{ px: 2, textAlign: "center", position: "relative" }}>
          <Avatar
            src={`/api/store/photo/${logo}`}
            alt={name}
            sx={{
              width: 68,
              height: 68,
              border: "3px solid #fff",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              bgcolor: "#fff",
              mx: "auto",
              mt: -4,
              mb: 0.8,
            }}
          />

          <Typography variant="h6" sx={{ fontWeight: 800, color: "#0f172a", lineHeight: 1.2, mb: 0.3 }}>
            {name}
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, color: "#64748b", fontSize: "0.8rem", mb: 0.8 }}>
            <LocationOnIcon sx={{ fontSize: 14 }} />
            <span>{address.cidade || ""} {address.estado ? `- ${address.estado}` : ""}</span>
            <FiberManualRecordIcon sx={{ fontSize: 4 }} />
            <Link to="/sobre" style={{ color: primaryColor, textDecoration: "none", fontWeight: 700 }}>
              Info
            </Link>
          </Box>
        </Box>
      </Box>
    );
  }

  renderAnnouncementsAndBanners() {
    const { announcements, promotionalBanners } = this.state.store;
    const hasAnnouncements = announcements && announcements.length > 0;
    const hasBanners = promotionalBanners && promotionalBanners.length > 0;

    if (!hasAnnouncements && !hasBanners) return null;

    return (
      <Box sx={{ mb: 3 }}>
        {hasAnnouncements && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 2.5 }}>
            {announcements.map((item, idx) => (
              <Alert
                key={item.id || idx}
                severity={item.type || "info"}
                icon={<CampaignIcon />}
                sx={{
                  borderRadius: 2.5,
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                  "& .MuiAlert-message": { width: "100%" },
                }}
              >
                {item.title && <AlertTitle sx={{ fontWeight: 700 }}>{item.title}</AlertTitle>}
                {item.message || item.descricao || item.texto}
              </Alert>
            ))}
          </Box>
        )}

        {hasBanners && (
          <Box
            sx={{
              display: "flex",
              gap: 2,
              overflowX: "auto",
              pb: 1,
              "::-webkit-scrollbar": { height: 6 },
              "::-webkit-scrollbar-thumb": { bgcolor: "#cbd5e1", borderRadius: 3 },
            }}
          >
            {promotionalBanners.map((banner, idx) => {
              const bannerContent = (
                <CardMedia
                  component="img"
                  image={`${apiUrl}/store/photo/${banner.image || banner.imagem || banner}`}
                  alt={banner.title || `Banner ${idx + 1}`}
                  sx={{
                    width: { xs: 260, sm: 340, md: 400 },
                    height: { xs: 110, sm: 140, md: 160 },
                    objectFit: "cover",
                    borderRadius: 3,
                    boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
                    flexShrink: 0,
                    transition: "transform 0.2s ease",
                    "&:hover": { transform: "scale(1.01)" },
                  }}
                />
              );

              return banner.link ? (
                <Box
                  key={banner.id || idx}
                  component={banner.link.startsWith("http") ? "a" : Link}
                  to={!banner.link.startsWith("http") ? banner.link : undefined}
                  href={banner.link.startsWith("http") ? banner.link : undefined}
                  target={banner.link.startsWith("http") ? "_blank" : undefined}
                  rel="noopener noreferrer"
                  sx={{ textDecoration: "none", flexShrink: 0 }}
                >
                  {bannerContent}
                </Box>
              ) : (
                <Box key={banner.id || idx} sx={{ flexShrink: 0 }}>
                  {bannerContent}
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    );
  }

  // NAVEGAÇÃO DE CATEGORIAS NO MOBILE
  renderMobileCategoryNav() {
    const { categories } = this.state.store;
    const { activeCategoryAnchor, searchQuery, viewMode } = this.state;
    const primaryColor = this.context.data.color || "#1976d2";

    if (searchQuery) return null;

    return (
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 1100,
          bgcolor: "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid #e2e8f0",
          py: 1,
          px: 2,
          mb: 2,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 1,
            overflowX: "auto",
            flexGrow: 1,
            scrollBehavior: "smooth",
            "::-webkit-scrollbar": { display: "none" },
          }}
        >
          {categories.map((cat) => {
            const isSelected = activeCategoryAnchor === cat.anchor;
            return (
              <Chip
                key={cat.id}
                label={cat.name}
                onClick={() => this.scrollToCategory(cat.anchor)}
                sx={{
                  fontWeight: isSelected ? 800 : 600,
                  bgcolor: isSelected ? primaryColor : "#f1f5f9",
                  color: isSelected ? "#fff" : "#475569",
                  borderRadius: 2,
                  px: 0.5,
                  height: 32,
                  fontSize: "0.8rem",
                  "&:hover": {
                    bgcolor: isSelected ? primaryColor : "#e2e8f0",
                  },
                }}
              />
            );
          })}
        </Box>

        <Box sx={{ display: "flex", borderLeft: "1px solid #e2e8f0", pl: 0.5, flexShrink: 0 }}>
          <IconButton size="small" sx={{ color: viewMode === "list" ? primaryColor : "#94a3b8" }} onClick={() => this.setViewMode("list")}>
            <ViewListIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" sx={{ color: viewMode === "grid" ? primaryColor : "#94a3b8" }} onClick={() => this.setViewMode("grid")}>
            <ViewModuleIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" sx={{ color: viewMode === "compact" ? primaryColor : "#94a3b8" }} onClick={() => this.setViewMode("compact")}>
            <ViewHeadlineIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    );
  }

  // SIDEBAR LATERAL DESKTOP NAVEGÁVEL & STICKY
  renderDesktopSidebar() {
    const { categories, products } = this.state.store;
    const { activeCategoryAnchor, searchQuery, viewMode } = this.state;
    const primaryColor = this.context.data.color || "#1976d2";

    if (searchQuery) return null;

    return (
      <Box
        sx={{
          position: "sticky",
          top: 24,
          alignSelf: "start",
          bgcolor: "#ffffff",
          borderRadius: 3,
          border: "1px solid #e2e8f0",
          p: 2,
          boxShadow: "0 4px 20px rgba(0,0,0,0.03)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5, pb: 1.5, borderBottom: "1px solid #f1f5f9" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CategoryIcon sx={{ color: primaryColor, fontSize: 20 }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 800, color: "#0f172a", fontSize: "0.95rem" }}>
              Categorias
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 0.25, bgcolor: "#f8fafc", p: 0.5, borderRadius: 2 }}>
            <Tooltip title="Exibição em Grade">
              <IconButton size="small" sx={{ color: viewMode === "grid" ? primaryColor : "#94a3b8", bgcolor: viewMode === "grid" ? "#fff" : "transparent" }} onClick={() => this.setViewMode("grid")}>
                <ViewModuleIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Exibição em Lista">
              <IconButton size="small" sx={{ color: viewMode === "list" ? primaryColor : "#94a3b8", bgcolor: viewMode === "list" ? "#fff" : "transparent" }} onClick={() => this.setViewMode("list")}>
                <ViewListIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Exibição Compacta">
              <IconButton size="small" sx={{ color: viewMode === "compact" ? primaryColor : "#94a3b8", bgcolor: viewMode === "compact" ? "#fff" : "transparent" }} onClick={() => this.setViewMode("compact")}>
                <ViewHeadlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <List disablePadding sx={{ display: "flex", flexDirection: "column", gap: 0.5, maxHeight: "calc(100vh - 160px)", overflowY: "auto" }}>
          {categories.map((cat) => {
            const isSelected = activeCategoryAnchor === cat.anchor;
            const count = products.filter((p) => p.categoryId === cat.id).length;

            return (
              <ListItemButton
                key={cat.id}
                selected={isSelected}
                onClick={() => this.scrollToCategory(cat.anchor)}
                sx={{
                  borderRadius: 2,
                  py: 1,
                  px: 1.5,
                  transition: "all 0.15s ease",
                  "&.Mui-selected": {
                    bgcolor: `${primaryColor}12`,
                    color: primaryColor,
                    borderLeft: `3px solid ${primaryColor}`,
                    "&:hover": { bgcolor: `${primaryColor}18` },
                  },
                  "&:hover": { bgcolor: "#f8fafc" },
                }}
              >
                <ListItemText
                  primary={cat.name}
                  primaryTypographyProps={{
                    fontSize: "0.875rem",
                    fontWeight: isSelected ? 800 : 600,
                    color: isSelected ? primaryColor : "#334155",
                  }}
                />
                <Chip
                  label={count}
                  size="small"
                  sx={{
                    height: 20,
                    fontSize: "0.725rem",
                    fontWeight: 700,
                    bgcolor: isSelected ? primaryColor : "#f1f5f9",
                    color: isSelected ? "#ffffff" : "#64748b",
                  }}
                />
              </ListItemButton>
            );
          })}
        </List>
      </Box>
    );
  }

  // CARD MODO LISTA
  renderProductList(product, menorImagem, precoMin) {
    const primaryColor = this.context.data.color || "#1976d2";

    return (
      <Grid item size={{ xs: 12 }} key={product.id}>
        <Card
          elevation={0}
          sx={{
            borderRadius: 3,
            bgcolor: "#fff",
            border: "1px solid #e2e8f0",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              borderColor: primaryColor,
              boxShadow: "0 6px 18px rgba(0,0,0,0.05)",
            },
          }}
        >
          <CardActionArea component={Link} to={`/produto/${product.slug}`} sx={{ display: "flex", p: 1.5, height: "100%" }}>
            <Box sx={{ display: "flex", flexDirection: "column", flex: 1, pr: 2 }}>
              <Typography sx={{ fontSize: "1rem", fontWeight: 700, color: "#0f172a", lineHeight: 1.3, mb: 0.5 }}>
                {product.nome}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#64748b",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  lineHeight: 1.4,
                  fontSize: "0.85rem",
                  mb: 1.25,
                }}
              >
                {product.descricao || "Saiba mais sobre este item."}
              </Typography>
              <Typography variant="body1" sx={{ mt: "auto", fontWeight: 800, color: primaryColor, fontSize: "1.05rem" }}>
                {precoMin.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
              </Typography>
            </Box>

            <CardMedia
              component="img"
              loading="lazy"
              sx={{
                width: 100,
                height: 100,
                objectFit: "cover",
                borderRadius: 2.5,
                bgcolor: "#f8fafc",
                border: "1px solid #f1f5f9",
                flexShrink: 0,
              }}
              image={menorImagem?.name ? `/api/store/photo/${menorImagem.name}` : "/api/store/photo/sem-imagem.jpg"}
              alt={product.nome}
            />
          </CardActionArea>
        </Card>
      </Grid>
    );
  }

  // CARD MODO GRADE (REDESENHADO PARA DESKTOP)
  renderProductGrid(product, menorImagem, precoMin) {
    const primaryColor = this.context.data.color || "#1976d2";

    return (
      <Grid item size={{ xs: 6, sm: 6, md: 4 }} key={product.id}>
        <Card
          elevation={0}
          sx={{
            height: "100%",
            borderRadius: 3,
            bgcolor: "#ffffff",
            border: "1px solid #e2e8f0",
            display: "flex",
            flexDirection: "column",
            transition: "transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease",
            "&:hover": {
              borderColor: primaryColor,
              transform: "translateY(-4px)",
              boxShadow: "0 12px 24px rgba(0,0,0,0.06)",
            },
          }}
        >
          <CardActionArea
            component={Link}
            to={`/produto/${product.slug}`}
            sx={{ display: "flex", flexDirection: "column", height: "100%", alignItems: "stretch" }}
          >
            <Box sx={{ position: "relative", overflow: "hidden", pt: "62%" }}>
              <CardMedia
                component="img"
                loading="lazy"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  bgcolor: "#f8fafc",
                }}
                image={menorImagem?.name ? `/api/store/photo/${menorImagem.name}` : "/api/store/photo/sem-imagem.jpg"}
                alt={product.nome}
              />
            </Box>

            <CardContent sx={{ p: 2, flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
              <Box sx={{ mb: 1.5 }}>
                <Typography
                  sx={{
                    fontSize: "0.95rem",
                    fontWeight: 700,
                    color: "#0f172a",
                    lineHeight: 1.3,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    minHeight: "2.6em",
                    mb: 0.5,
                  }}
                >
                  {product.nome}
                </Typography>

                {product.descricao && (
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#64748b",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      fontSize: "0.8rem",
                      lineHeight: 1.35,
                    }}
                  >
                    {product.descricao}
                  </Typography>
                )}
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: "auto", pt: 1, borderTop: "1px border-dash #f1f5f9" }}>
                <Typography variant="body1" sx={{ fontWeight: 800, color: primaryColor, fontSize: "1.05rem" }}>
                  {precoMin.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                </Typography>
                <ArrowForwardIcon sx={{ fontSize: 18, color: primaryColor, opacity: 0.8 }} />
              </Box>
            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>
    );
  }

  // CARD MODO COMPACTO
  renderProductCompact(product, menorImagem, precoMin) {
    const primaryColor = this.context.data.color || "#1976d2";

    return (
      <Grid item size={{ xs: 12 }} key={product.id}>
        <Card
          elevation={0}
          sx={{
            borderRadius: 2,
            bgcolor: "#fff",
            border: "1px solid #e2e8f0",
            transition: "border-color 0.2s, box-shadow 0.2s",
            "&:hover": { borderColor: primaryColor, boxShadow: "0 2px 8px rgba(0,0,0,0.04)" },
          }}
        >
          <CardActionArea component={Link} to={`/produto/${product.slug}`} sx={{ p: 1.25, display: "flex", alignItems: "center" }}>
            <CardMedia
              component="img"
              loading="lazy"
              sx={{
                width: 48,
                height: 48,
                objectFit: "cover",
                borderRadius: 1.5,
                mr: 2,
                bgcolor: "#f8fafc",
                border: "1px solid #f1f5f9",
                flexShrink: 0,
              }}
              image={menorImagem?.name ? `/api/store/photo/${menorImagem.name}` : "/api/store/photo/sem-imagem.jpg"}
              alt={product.nome}
            />
            <Box sx={{ flexGrow: 1, overflow: "hidden", pr: 2 }}>
              <Typography noWrap sx={{ fontSize: "0.9rem", fontWeight: 700, color: "#0f172a" }}>
                {product.nome}
              </Typography>
              <Typography noWrap variant="caption" sx={{ color: "#64748b" }}>
                {product.descricao || "Toque para ver detalhes"}
              </Typography>
            </Box>
            <Typography sx={{ fontWeight: 800, color: primaryColor, whiteSpace: "nowrap", fontSize: "0.95rem" }}>
              {precoMin.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
            </Typography>
          </CardActionArea>
        </Card>
      </Grid>
    );
  }

  renderMenu() {
    const { categories, products } = this.state.store;
    const { searchQuery, viewMode } = this.state;

    if (categories.length === 0) {
      return (
        <Container maxWidth="md" sx={{ py: 8, textAlign: "center", color: "#64748b" }}>
          <Typography variant="h6" sx={{ color: "#0f172a", fontWeight: 700 }}>
            {this.getSegmentTerm(this.context.data.segment)} indisponível
          </Typography>
          <Typography variant="body2">Volte novamente mais tarde.</Typography>
        </Container>
      );
    }

    const term = searchQuery.toLowerCase();
    const filteredProducts = products.filter(
      (p) =>
        p.nome.toLowerCase().includes(term) ||
        (p.descricao && p.descricao.toLowerCase().includes(term))
    );

    return (
      <Box>
        {filteredProducts.length === 0 && searchQuery && (
          <Box sx={{ py: 6, textAlign: "center", color: "#64748b" }}>
            <Typography variant="h6" sx={{ color: "#0f172a", fontWeight: 700 }}>
              Nenhum produto encontrado
            </Typography>
            <Typography variant="body2">Tente buscar por outro termo.</Typography>
          </Box>
        )}

        {categories.map((category) => {
          const catProducts = filteredProducts.filter((p) => p.categoryId === category.id);

          if (catProducts.length === 0) return null;

          return (
            <Box key={category.id} id={category.anchor} sx={{ mb: 4, scrollMarginTop: 30 }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 800,
                  color: "#0f172a",
                  mb: 2,
                  fontSize: { xs: "1.1rem", sm: "1.3rem" },
                  letterSpacing: "-0.02em",
                }}
              >
                {category.name}
              </Typography>

              <Grid container spacing={this.props.isMobile ? 1.5 : 2.5}>
                {catProducts.map((product) => {
                  const menorImagem = product.image_list?.sort((a, b) => a.position - b.position)[0];
                  const precoMin = product.preco || 0;

                  if (viewMode === "grid") {
                    return this.renderProductGrid(product, menorImagem, precoMin);
                  }
                  if (viewMode === "compact") {
                    return this.renderProductCompact(product, menorImagem, precoMin);
                  }
                  return this.renderProductList(product, menorImagem, precoMin);
                })}
              </Grid>
            </Box>
          );
        })}
      </Box>
    );
  }

  // BOTÃO DO CARRINHO FLUTUANTE
  renderCartFab() {
    const { cart } = this.state.store;
    const primaryColor = this.context.data.color || "#1976d2";

    if (!cart || cart.length === 0) return null;

    const totalItems = cart.reduce((acc, item) => acc + (item.quantidade || 1), 0);
    const totalValue = cart.reduce((acc, item) => acc + ((item.preco || 0) * (item.quantidade || 1)), 0);

    return (
      <Fab
        variant="extended"
        color="primary"
        aria-label="cart"
        component={Link}
        to="/carrinho"
        sx={{
          position: "fixed",
          bottom: { xs: 16, sm: 28 },
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1200,
          bgcolor: primaryColor,
          color: "#ffffff",
          fontWeight: 700,
          px: 3.5,
          py: 1,
          width: { xs: "calc(100% - 32px)", sm: "auto" },
          minWidth: 320,
          maxWidth: 440,
          justifyContent: "space-between",
          boxShadow: "0 12px 32px rgba(0,0,0,0.22)",
          "&:hover": { bgcolor: primaryColor, transform: "translateX(-50%) scale(1.02)" },
          transition: "all 0.2s ease",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Badge badgeContent={totalItems} color="error" sx={{ mr: 2 }}>
            <ShoppingCartIcon />
          </Badge>
          <span>Ver Carrinho</span>
        </Box>
        <Typography sx={{ fontWeight: 800, fontSize: "1.05rem" }}>
          {totalValue.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
        </Typography>
      </Fab>
    );
  }

  render() {
    const { isLoading, error } = this.state.store;
    const { isMobile } = this.props;
    const primaryColor = this.context.data.color || "#1976d2";

    if (error) {
      return (
        <Box sx={{ p: 4, textAlign: "center" }}>
          <Typography color="error" variant="h6">Ops! Ocorreu um problema.</Typography>
          <Typography color="text.secondary">{error.message}</Typography>
        </Box>
      );
    }

    if (isLoading) {
      return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", bgcolor: "#f8fafc" }}>
          <CircularProgress sx={{ color: primaryColor }} />
        </Box>
      );
    }

    return (
      <Box sx={{ bgcolor: "#f8fafc", minHeight: "100vh", position: "relative", pb: 6 }}>
        {/* Header Responsivo */}
        {isMobile ? this.renderMobileHeader() : this.renderDesktopHeader()}

        {/* Menu de Categorias + Seletor Sticky no Mobile */}
        {isMobile && this.renderMobileCategoryNav()}

        {/* Conteúdo Principal Ajustado */}
        <Container maxWidth={isMobile ? "md" : "lg"} sx={{ px: { xs: 2, sm: 3 }, pb: 8 }}>
          {this.renderAnnouncementsAndBanners()}

          {/* Estrutura Desktop com Sidebar Fixa */}
          {isMobile ? (
            this.renderMenu()
          ) : (
            <Grid container spacing={4}>
              <Grid item size={{ md: 3, lg: 3 }}>
                {this.renderDesktopSidebar()}
              </Grid>
              <Grid item size={{ md: 9, lg: 9 }}>
                {this.renderMenu()}
              </Grid>
            </Grid>
          )}
        </Container>

        {/* Carrinho Flutuante */}
        {this.renderCartFab()}
      </Box>
    );
  }
}

// Wrapper Funcional para injetar a detecção de breakpoint de tela
export default function HomeDeliveryWithMediaQueries(props) {
  const theme = useTheme();
  // md = 900px no Material-UI
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return <HomeDelivery {...props} isMobile={isMobile} />;
}